import React from 'react'
import { useRouter } from 'next/router'

//* Components
import Image from 'components/common/Image'

//* Style
import LogoStyle from './style'
import { withUIContext } from 'context'

const Logo = ({ closeBurgerMenu }) => {
	const router = useRouter()

	const handleLogoClick = () => {
		router.push('/')
		window.scrollTo(0, 0)
		closeBurgerMenu()
	}

	return (
		<LogoStyle onClick={() => handleLogoClick()}>
			<Image src='/images/logo.svg' />
		</LogoStyle>
	)
}

export default withUIContext(Logo, ['closeBurgerMenu'])
